// API-Wrapper fuer ComeFit Belege (Backend: routers_belege.py + routers_belege_buchhaltung.py). Gemeinsam genutzt vom Finanz-Reiter "Belege".
// Die Berechtigung (ein freigegebenes Admin-Konto) entscheidet ausschliesslich der SERVER; die Oberflaeche blendet nur aus.
// Das Sitzungs-Cookie wird vom globalen fetch-Override in App.js mitgesendet.
export const API = ["localhost", "127.0.0.1"].includes(window.location.hostname)
  ? "http://localhost:8000"
  : `${window.location.protocol}//${window.location.hostname}`;

export class NetzFehler extends Error {}

async function anfrage(pfad, { methode = "GET", body, params } = {}) {
  const url = new URL(`${API}/belege${pfad}`);
  if (params) Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, v); });
  const optionen = { method: methode, headers: {} };
  if (body instanceof FormData) optionen.body = body;
  else if (body !== undefined) { optionen.headers["Content-Type"] = "application/json"; optionen.body = JSON.stringify(body); }
  let res;
  try { res = await fetch(url, optionen); } catch (e) { throw new NetzFehler("Keine Verbindung zum Server"); }
  const daten = await res.json().catch(() => ({}));
  if (!res.ok) { const f = new Error(typeof daten.detail === "string" ? daten.detail : `Fehler ${res.status}`); f.status = res.status; throw f; }
  return daten;
}

const post = (pfad, body) => anfrage(pfad, { methode: "POST", body: body === undefined ? {} : body });

// Funktionsstufe der Belegverwaltung (vom Server gemeldet, serverseitig erzwungen). "basis" = nur manuelle Verwaltung; die Oberflaeche blendet den Rest nur aus.
export const belegeStufe = { erweitert: false, uploadZugang: false, heic: false };
export const ERWEITERTE_BEREICHE = ["ohne_kontierung", "nicht_an_datev", "ohne_bestaetigung", "amazon_rechnung_fehlt"];   // Arbeitslisten, die es nur in der erweiterten Stufe gibt

export const belegeApi = {
  status: () => anfrage("/status"),
  upload: (formData) => anfrage("/upload", { methode: "POST", body: formData }),
  liste: (params) => anfrage("", { params }),
  detail: (id) => anfrage(`/${id}`),
  aendern: (id, daten) => anfrage(`/${id}`, { methode: "PATCH", body: daten }),
  statusSetzen: (id, daten) => anfrage(`/${id}/status`, { methode: "POST", body: daten }),
  nachweis: (id, formData) => anfrage(`/${id}/nachweis`, { methode: "POST", body: formData }),
  abgleich: (id) => anfrage(`/${id}/abgleich`, { methode: "POST" }),
  bankBestaetigen: (id, zuordnungen, extra = {}) => anfrage(`/${id}/bank/bestaetigen`, { methode: "POST", body: { zuordnungen, ...extra } }),
  bankVerwerfen: (id, bankumsatzId) => anfrage(`/${id}/bank/verwerfen`, { methode: "POST", body: { bankumsatz_id: bankumsatzId } }),
  datevVorschau: (id) => anfrage(`/${id}/datev-vorschau`),
  datevManuell: (id, referenz) => post(`/${id}/datev/manuell`, { referenz }),
  teilzahlung: (id) => anfrage(`/${id}/teilzahlung-vorschlaege`),

  // Erkennung / OCR
  ocrStatus: () => anfrage("/ocr-status"),
  erkennung: (id) => anfrage(`/${id}/erkennung`),
  erkennungStarten: (id) => post(`/${id}/erkennung`),
  erkennungOffene: () => post("/erkennung/offene"),

  // Posteingang (IMAP)
  postfachStatus: () => anfrage("/postfach/status"),
  postfachLauf: (modus, tage = 14) => post("/postfach/lauf", { modus, tage }),
  absenderNeu: (muster, lieferant) => post("/postfach/absender", { muster, lieferant: lieferant || null }),
  absenderWeg: (id) => anfrage(`/postfach/absender/${id}`, { methode: "DELETE" }),

  // Amazon
  amazonImport: (formData) => anfrage("/amazon/import", { methode: "POST", body: formData }),
  amazonImporte: () => anfrage("/amazon/importe"),

  // Bankabgleich
  abgleichLauf: () => post("/abgleich/lauf"),
  sichereTreffer: (minScore = 90) => anfrage("/abgleich/sichere", { params: { min_score: minScore } }),
  sichereBestaetigen: (ids, minScore = 90) => post("/abgleich/sichere/bestaetigen", { beleg_ids: ids, min_score: minScore }),
  umsaetzeOhneBeleg: (params = {}) => anfrage("/umsaetze-ohne-beleg", { params: typeof params === "number" ? { limit: params } : params }),
  umsatzVorschlaege: (id) => anfrage(`/umsaetze/${id}/vorschlaege`),
  sammelvorschlaege: (id) => anfrage(`/umsaetze/${id}/sammelvorschlaege`),
  umsatzSammel: (id, belege, statusWeiter = false) => post(`/umsaetze/${id}/sammel-bestaetigen`, { belege, status_weiter: statusWeiter }),
  keinBeleg: (id, grund) => post(`/umsaetze/${id}/kein-beleg`, { grund }),
  keinBelegWeg: (id) => anfrage(`/umsaetze/${id}/kein-beleg`, { methode: "DELETE" }),

  // Einstellungen / Kontierung (SKR03)
  einstellungen: () => anfrage("/einstellungen"),
  einstellungenSetzen: (werte) => anfrage("/einstellungen", { methode: "PUT", body: { werte } }),
  kontenSuche: (q) => anfrage("/konten/suche", { params: { q } }),
  regeln: () => anfrage("/kontierung/regeln"),
  regelNeu: (daten) => post("/kontierung/regeln", daten),
  regelWeg: (id) => anfrage(`/kontierung/regeln/${id}`, { methode: "DELETE" }),
  kontierungOffen: () => anfrage("/kontierung/offen"),
  kontierungStapel: () => post("/kontierung/stapel"),
  kontierungVorschlag: (id) => post(`/${id}/kontierung/vorschlag`),
  kontierung: (id) => anfrage(`/${id}/kontierung`),
  kontierungBestaetigen: (id, zeilen, unbekanntErlauben = false) => post(`/${id}/kontierung/bestaetigen`, { zeilen, unbekannt_erlauben: unbekanntErlauben }),

  // Fehlende Belege
  uebersichtFehlend: async (tage = 14) => {
    const u = await anfrage("/uebersicht-fehlend", { params: { tage } });
    if (belegeStufe.erweitert || !u || !u.bereiche) return u;
    const bereiche = Object.fromEntries(Object.entries(u.bereiche).filter(([k]) => !ERWEITERTE_BEREICHE.includes(k)));
    return { ...u, bereiche, gesamt: Object.values(bereiche).reduce((n, b) => n + (b.anzahl || 0), 0) };
  },
  uebersichtCsvUrl: (tage = 14) => `${API}/belege/uebersicht-fehlend.csv?tage=${tage}`,

  // DATEV-Upload-Mail
  datevStatus: () => anfrage("/datev/status"),
  datevVorbereiten: (ids) => post("/datev/uebergaben", { beleg_ids: ids }),
  datevFreigeben: (id, passwort) => post(`/datev/uebergaben/${id}/freigeben`, { passwort }),
  datevSenden: (id) => post(`/datev/uebergaben/${id}/senden`),
  datevErneut: (id, nichtsGesendet) => post(`/datev/uebergaben/${id}/erneut`, { nichts_gesendet_bestaetigt: nichtsGesendet }),
  datevStornieren: (id, grund) => post(`/datev/uebergaben/${id}/stornieren`, { grund }),

  // EXTF
  extfListe: () => anfrage("/extf"),
  extfVorschau: (daten) => post("/extf/vorschau", daten),
  extfErzeugen: (daten) => post("/extf", daten),
  extfDateiUrl: (id) => `${API}/belege/extf/${id}/datei`,
  extfWeitergegeben: (id) => post(`/extf/${id}/weitergegeben`),
  extfStornieren: (id, grund) => post(`/extf/${id}/stornieren`, { grund }),

  // Upload-Zugaenge (Smartphone der Ehefrau): nur Verwaltung
  zugaenge: () => anfrage("/zugaenge"),
  zugangAnlegen: (bezeichnung, passwort) => anfrage("/zugaenge", { methode: "POST", body: { bezeichnung, passwort } }),
  zugangNeuEinrichten: (id, passwort) => anfrage(`/zugaenge/${id}/einladung`, { methode: "POST", body: { passwort } }),
  zugaengeAlleWiderrufen: () => anfrage("/zugaenge/alle-widerrufen", { methode: "POST" }),
  zugangWiderrufen: (id) => anfrage(`/zugaenge/${id}/widerrufen`, { methode: "POST" }),
  dateiUrl: (id) => `${API}/belege/${id}/datei`,
  originalUrl: (id, dateiId) => `${API}/belege/${id}/original/${dateiId}`,
};

// Parallelbuchhaltung (INTERN / VORLAEUFIG): eigene Endpunkte unter /belege/pb, getrennt von allen Bestandsdaten. Es gibt keinen Versandweg.
export const pbApi = {
  status: () => anfrage("/pb/status"),
  einstellung: (schluessel, wert) => anfrage("/pb/einstellungen", { methode: "PUT", body: { schluessel, wert } }),
  zuordnung: () => anfrage("/pb/zuordnung"),
  zuordnungSetzen: (body) => anfrage("/pb/zuordnung", { methode: "PUT", body }),
  zuordnungLoeschen: (id) => anfrage(`/pb/zuordnung/${id}`, { methode: "DELETE" }),
  vorschlaege: () => post("/pb/zuordnung/vorschlaege"),
  lauf: (body) => post("/pb/lauf", body),
  laeufe: () => anfrage("/pb/laeufe"),
  buchungen: (params) => anfrage("/pb/buchungen", { params }),
  pruefen: (id, body) => post(`/pb/buchungen/${id}/pruefung`, body),
  uebersicht: (von, bis) => anfrage("/pb/uebersicht", { params: { von, bis } }),
  // Phase 3-5: Befunde aus den Kanzlei-Unterlagen, eigene SuSa/BWA, Kanzleivergleich (nur Lesen/Notizen), Bereitschaft der Rueckrechnung
  befunde: () => anfrage("/pb/befunde"),
  susa: (ym, ohneUnsichere) => anfrage("/pb/susa", { params: { ym, ohne_unsichere: ohneUnsichere ? 1 : "" } }),
  bwa: (ym, ohneUnsichere) => anfrage("/pb/bwa", { params: { ym, ohne_unsichere: ohneUnsichere ? 1 : "" } }),
  startsalden: () => anfrage("/pb/startsalden"),
  startsaldenSetzen: (ym) => post("/pb/startsalden", { ym }),
  kanzleiMonate: () => anfrage("/pb/kanzlei/monate"),
  selbstpruefung: (ym) => anfrage("/pb/kanzlei/selbstpruefung", { params: { ym } }),
  klassifikation: () => anfrage("/pb/klassifikation"),
  klassVorschlaege: () => post("/pb/klassifikation/vorschlaege"),
  klassSetzen: (body) => anfrage("/pb/klassifikation", { methode: "PUT", body }),
  vergleich: (ym) => anfrage("/pb/vergleich", { params: { ym } }),
  vergleichSpeichern: (ym) => post("/pb/vergleich", { ym }),
  vergleichGespeichert: (ym) => anfrage("/pb/vergleich/gespeichert", { params: { ym } }),
  verlauf: (von, bis) => anfrage("/pb/vergleich/verlauf", { params: { von, bis } }),
  notiz: (body) => anfrage("/pb/vergleich/notiz", { methode: "PUT", body }),
  bereitschaft: (von, bis) => anfrage("/pb/rueckrechnung/bereitschaft", { params: { von, bis } }),
  // Umsatzsteuer-Voranmeldung (intern/vorlaeufig; es wird nichts uebermittelt)
  ustvaKennzahlen: (jahr) => anfrage("/pb/ustva/kennzahlen", { params: { jahr } }),
  ustvaBerechnung: (jahr, zeitraum, methode) => anfrage("/pb/ustva/berechnung", { params: { jahr, zeitraum, methode } }),
  ustvaDetail: (jahr, zeitraum, kz) => anfrage("/pb/ustva/detail", { params: { jahr, zeitraum, kz } }),
  ustvaSpeichern: (jahr, zeitraum) => post("/pb/ustva/speichern", { jahr, zeitraum }),
  ustvaLaeufe: () => anfrage("/pb/ustva/laeufe"),
  ustvaProtokolle: () => anfrage("/pb/ustva/protokolle"),
  ustvaVergleich: (jahr, zeitraum) => anfrage("/pb/ustva/vergleich", { params: { jahr, zeitraum } }),
  ustvaKonten: () => anfrage("/pb/ustva/konten"),
  ustvaKontenVorschlaege: () => post("/pb/ustva/konten/vorschlaege"),
  ustvaKontenBestaetigen: () => post("/pb/ustva/konten/bestaetigen"),
  ustvaKontoSetzen: (body) => anfrage("/pb/ustva/konten", { methode: "PUT", body }),
  ustvaMethode: () => anfrage("/pb/ustva/methode"),
  ustvaMethodeBestaetigen: (body) => post("/pb/ustva/methode-bestaetigen", body),
  ustvaXml: (body) => post("/pb/ustva/elster-xml", body),
  ustvaEric: () => anfrage("/pb/ustva/eric"),
  // Dateidownload (CSV/JSON): Sitzungs-Cookie wird vom globalen fetch-Override mitgesendet
  ustvaDownload: async (jahr, zeitraum, format) => {
    const res = await fetch(`${API}/belege/pb/ustva/export?jahr=${jahr}&zeitraum=${zeitraum}&format=${format}`);
    if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(typeof d.detail === "string" ? d.detail : `Fehler ${res.status}`); }
    return res.blob();
  },
};

export const STATUS_NAME = {
  eingegangen: "Eingegangen", geprueft: "Geprüft", bankumsatz_zugeordnet: "Bankumsatz zugeordnet",
  an_datev_gesendet: "An DATEV gesendet", in_datev_bestaetigt: "In DATEV bestätigt",
  abgelehnt: "Abgelehnt", dublette: "Dublette", rueckfrage: "Rückfrage",
};
export const BELEGARTEN = [
  ["eingangsrechnung", "Eingangsrechnung"], ["kassenbon", "Kassenbon / Quittung"], ["privat_ausgelegt", "Privat ausgelegt"],
  ["gutschrift", "Gutschrift / Erstattung"], ["sonstiges", "Sonstiges"],
];
export const NAECHSTER_STATUS = { eingegangen: "geprueft", geprueft: "bankumsatz_zugeordnet" };
